import {Component, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {MatButtonModule} from "@angular/material/button";
import {MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatIconModule} from "@angular/material/icon";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {HttpService} from "../../services/http/http.service";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'msg-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule],
})
export class MsgDialog implements OnInit {
  data: any = {
    email: '',
    messaggio: '',
    allegati: []
  }
  userForm: any;
  constructor(
    public dialogRef: MatDialogRef<MsgDialog>,
    public api: HttpService,
    private snackBar: MatSnackBar
    // @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.userForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      messaggio: new FormControl(''),
    });
  }

  send() {
    let data = {"testoEmail":this.userForm.get('messaggio').value,"emailMittente":this.userForm.get('email').value,"breadcrumb":"","idSessioneEsame":null}
    let Form = JSON.stringify(data);
    const uploadFormData: any = new FormData();
    uploadFormData.append("mail", new Blob([Form], {
      type: "application/json"
    }));

    for (const file of this.data.allegati) {
      uploadFormData.append("files", file, file.name);
    }

    if (this.data.allegati.length == 0) {
      uploadFormData.append("files", null);
    }

    this.api.assistenza(uploadFormData).subscribe({
      next: (response: any) => {
        this.snackBar.open('Email inviata con successo', 'close', { panelClass: 'successSnack' });
        this.dialogRef.close();
      }
    })
  }

  onFileSelected(event: any) {
    // const file: File = event.target.files[0];
    // if (file) {
    //   this.data.allegati.push(file);
    // }
    this.data.allegati = event.target.files;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


}
